import * as pdfjsLib from 'pdfjs-dist';

type PdfjsModule = typeof pdfjsLib;

export async function loadPdfJsModule(): Promise<PdfjsModule> {
    pdfjsLib.GlobalWorkerOptions.workerSrc = 'pdfjs-dist/build/pdf.worker.mjs';
    return import(/* webpackChunkName: "pdfjs-dist" */ 'pdfjs-dist/webpack.mjs');
}